module.exports = __webpack_public_path__ + "static/img/BE.fa1aaf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/BE.svg
// module id = ukDl
// module chunks = 66